import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppState } from 'src/app/app.reducer';
import { currentUserDetails } from 'src/app/shared/selectors/auth.selector';

@Component({
    selector: 'app-page-with-sidebar-temp1',
    templateUrl: './page-with-sidebar.temp1.component.html',
    styleUrls: ['./page-with-sidebar.temp1.component.scss']
})
export class PageWithSidebarTemp1Component implements OnInit {
    isSidebarOpen = true;
    currentUserDetails$: Observable<any>;
    @Input() addContentPadding = true;
    @Input() hideSidebar: boolean;

    constructor(private store: Store<AppState>) { }

    ngOnInit() {
        this.currentUserDetails$ = this.store.select(currentUserDetails);
    }

    toggleSidebar() {
        this.isSidebarOpen = !this.isSidebarOpen;
    }

    onHideFilter() {
        const pageSidebar = document.getElementsByClassName('page__sidebar')[0];
        if (pageSidebar) {
            pageSidebar.classList.remove('page__sidebar--visible');
        }
        document.body.classList.remove('body-overflow-none');
    }
}
